<template>
  <div id="menu-upload">
    <h1>{{ $t("uploadsAndLinks.uploadFiles.title") }}</h1>
    <p>{{ $t("uploadsAndLinks.uploadFiles.directions") }}</p>
    <div class="input-container">
      <div class="row">
          <div class="col-3">
                                  <FileUploader
                                    :placeholder="$t('uploadsAndLinks.uploadFiles.file_ph')"
                                    :label="$t('uploadsAndLinks.uploadFiles.browse')"
                                    :fileUrl="fileUrl"
                                    @setFile="setFile"/>
                                  <div class="error-msg">
                                    <span v-if="$v.file.$error">{{ $t("uploadsAndLinks.uploadFiles.errors.file_required") }}</span>
                                  </div>
      </div>
         <div class="col-1">
          <center>
              <!-- 
              <input type="checkbox" id="chkpublic" v-model="chkpublic" @click="Check('chkpublic')" />
              <label for="checkbox">_{{$t('uploadsAndLinks.uploadFiles.public')}}</label>
              <br/>
              <input type="checkbox" id="chkprivate" v-model="chkprivate"  @click="Check('chkprivate')"/>
              <label for="checkbox">_{{$t('uploadsAndLinks.uploadFiles.private')}}</label> -->
              <input type="radio" id="chkpublic" value="true" v-model="picked">
              <label for="chkpublic">{{$t('uploadsAndLinks.uploadFiles.public')}}</label>
              <input type="radio" id="chkprivate" value="false" v-model="picked">
              <label for="chkprivate">{{$t('uploadsAndLinks.uploadFiles.private')}}</label>
              <br>
              <i style='font-size:24px' class='fas btn-outline-secondary' @click="showInf()">&#xf05a;</i>
        </center>
      </div>

              <div class="col-2">
              <center>
                 <button
          type="button"
          class="btn btn-dark control publish-btn"
          :disabled="isLoading"
          @click="ValidateUpload">
          {{ $t("uploadsAndLinks.uploadFiles.upload") }}
        </button>
              </center>
              </div>
      <div class="col-6">
       <div class="uploadInfo">{{ uploadStatus }}</div>
      </div>
      </div>
      
    </div>
   
    <!-- Menu table -->
    <div class="row">
      <div class="col-md-12">
        <div class="menu-table">
          <v-client-table
            v-if="uploadedFiles"
            :columns="table_options.columns"
            :options="table_options.options"
            :data="uploadedFiles">
          <template v-slot:copy="props">
         <center><i style='font-size:24px' class='fas btn-outline-secondary' @click="copyInf(props.row.url)">&#xf0c5;</i></center> 
          </template> 
          <template #isPublic="props">{{ translateStatus(props.row.isPublic) }}</template> 
           <template #url="props">
              <a target="_blank" :href="props.row.url"> {{$t('uploadsAndLinks.uploadFiles.link')}} </a>
            </template>
              <!-- <template #updatedAt="props">{{
              props.row.updatedAt | formatDate(appLang)
            }}</template>
            <template #date="props">{{
              props.row.date | formatDateOnly(appLang)
            }}</template> -->
            <template #createdAt="props">{{props.row.createdAt | formatDate(appLang)}}</template>
          </v-client-table>
        </div>
      </div>
    </div>
         <b-modal size="lg" centered ref="my-info" hide-footer  scrollable :title="$t('uploadsAndLinks.uploadFiles.info')"  tabindex="-1" >
         <center>
         <i style="font-size:50px; color:yellow" class="fa">&#xf05a;</i>
         <div v-if="appLang =='es'">
         <strong>Público:</strong>
                         Al subir el archivo, cualquier persona que tenga este enlace podrá tener acceso al documento. 
                         <br/>
                         Esto incluye personas fuera de la organización.
                <br/>
                <br/>
         <strong>Privado:</strong>
                          Documento que solo se visualiza en la Audi App, solo podrá ser compartido únicamente por el módulo de avisos y comunicados.
                 <br/>
         </div>
                <div v-if="appLang =='en'">
                        <strong>Public:</strong>
                                        By uploading the file, anyone with this link will be able to access the document.
                                        <br/>
                                        This includes people outside the organization.
                                        <br/>
                                        <br/>
                        <strong>Private:</strong>
                                          Document that is only displayed in the Audi App, can only be shared by the notifications and communications module.
                                          <br/>
                     
                </div>
                                          <br/>
                    <div class="col-md-2">
                           <button class="btn btn-dark mx-1" @click="Close()"> {{ $t("qrAccess.reports.close") }}</button>
                    </div> 
        </center>
    </b-modal>

         <b-modal size="lg" centered ref="my-warning" hide-footer  scrollable :title="$t('uploadsAndLinks.uploadFiles.upload')"  tabindex="-1" >
         <center>
         <i style="font-size:50px; color:red" class="fa">&#xf071;</i>
         <div v-if="appLang =='es'">
             <div v-if="picked == 'true'">
                  <strong>Público:</strong>
                         Al subir el archivo, cualquier persona que tenga este enlace podrá tener acceso al documento. 
                         <br/>
                         Esto incluye personas fuera de la organización.
                              <br/>
                              <br/>
                              <input type="checkbox" id="chkprivate" v-model="chkprivate"/>
                              <strong> Entiendo el riesgo de conceder acceso de lectura pública al documento cargado.</strong> 
               </div>
                <div v-else>
                           <strong>Privado:</strong>
                                            Documento que solo se visualiza en la Audi App, solo podrá ser compartido únicamente por el módulo de avisos y comunicados.
                            <br/>
                            <br/>
                      <input type="checkbox" id="chkprivate" v-model="chkprivate"/>
                     <strong>  Entiendo conceder acceso privado al documento cargado.</strong> 
                </div>
            </div>
                <div v-if="appLang =='en'">
                 <div v-if="picked == 'true'">
                    <strong>Public:</strong>
                                        By uploading the file, anyone with this link will be able to access the document.
                                        <br/>
                                        This includes people outside the organization.
                          <br/>
                          <br/>
                              <input type="checkbox" id="chkprivate" v-model="chkprivate"/>
                             <strong>  I understand the risk of granting public read access to the uploaded document.</strong> 
                        </div>
                           <div v-else>
                       <strong>Private:</strong>
                                          Document that is only displayed in the Audi App, can only be shared by the notifications and communications module.
                                          <br/>
                                          <br/>
                         <input type="checkbox" id="chkprivate" v-model="chkprivate"/>
                         <strong>I understand granting private access to the uploaded document.</strong> 
                      </div>
                </div>
                  <br/>
                   <div v-if="chkprivate ==true">
                    <div class="col-md-2">
                           <button class="btn btn-dark mx-1" @click="validateForm()"> {{ $t("uploadsAndLinks.uploadFiles.upload") }}</button>
                        </div> 
                    </div>
        </center>
    </b-modal>
  </div>
</template>

<script>

import { required } from "vuelidate/lib/validators";
import moment from "moment";
import S3_Handler from "@/lib/api/s3_handler";
import UPLOADED_FILES_API from "@/lib/api/UploadedFiles.js";
const FileUploader = () => import("@/components/FileUploader");
const s3 = new S3_Handler();
const api = new UPLOADED_FILES_API();

export default {
  components: {
    FileUploader
  },
  filters: {


    formatDateOnly: function(value, lang) {
      if (!value) return '';
      if (lang === 'es') {
        moment.locale("es-do");
      } else {
        moment.locale("en");
      }

      return moment(value).format("L");
    }
  },
  data: function() {
    return {
      picked:false,
      isLoading: false,
      file: null,
      fileUrl: null,
      uploadStatus: '',
      uploadedFiles: null,
      signedURL: null,
      chkpublic:false,
      chkprivate:false,
        columns: [
          "id",
          "createdAt",
          "email",
          "originalFileName",
          "url",
          "copy",
          "isPublic"],
    };
  },
  computed: {
    appLang: function() {
      return this.$store.getters['settings/currentLang'];
    },
    table_columns: function() {
      // const { uploadedFiles = [] } = this.uploadedFiles;
      // if (this.uploadedFiles) 
      // return Object.keys(this.uploadedFiles[0]);
       return this.columns;
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(`uploadsAndLinks.uploadFiles.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          texts: {
            filter: `${this.$t('components.vue_tables.filter')}:`,
            filterPlaceholder: this.$t('components.vue_tables.filter_ph')
          },
          headings: this.table_headings,
          sortable: ['date'],
          sortIcon: {
            base: 'fas',
            up: 'fa-sort-up',
            down: 'fa-sort-down',
            is: 'fa-sort'
          },
          perPage: 10,
          resizableColumns: false,
          perPageValues: [10, 25, 50, 100]
        }
      };
    }
  },
  validations: {
    file: {
      required
    }
  },
  beforeMount: async function() {
    await this.getUploadedFiles();
  },
  methods: {
       translateStatus (status) {
      if (status == true){
      status = this.$t("uploadsAndLinks.uploadFiles.table.headings.Yes")
      }
      else if(status == false){
       status = this.$t("uploadsAndLinks.uploadFiles.table.headings.No")
      }
       else if(status == null){
       status =  "-"
       }
       else {
        status
      }
      return status
    },
     showInf: function(){
      this.$refs['my-info'].show();
    },
       Close: function(){
      this.$refs['my-info'].hide();
    },
     copyInf: function(url){
        var c = document.createElement("textarea");
        c.innerText = url;
        document.body.appendChild(c);       
        c.select();
        document.execCommand("copy");
        document.body.removeChild(c);

            this.$store.commit("global/SET_ALERT", {
                msg: this.$t("uploadsAndLinks.uploadFiles.copyURL"),
                show: true,
                type: "success"
               });
    },
 
    // Check: function(chk){
    //  if(chk == "chkpublic" )
    //   {
    //          $("#chkpublic").prop("checked", true)
    //          $("#chkprivate").prop("checked", false)
    //       // this.chkpublic = true;
    //       // this.chkprivate = false;
    //   }
    //  else if(chk == "chkprivate" )
    //   {  
    //          $("#chkpublic").prop("checked", false)
    //          $("#chkprivate").prop("checked", true)
    //       // this.chkpublic = false;
    //       // this.chkprivate = true;
    //   } },
  
    getUploadedFiles: async function() {
      this.isLoading = true;
      this.$store.commit('global/SET_LOADING', true);
      try {
        var email = this.$store.getters["session/emailAdmin"];

        if(email=="admin@test.com"){
          email="";
        }
        const resp = await api.getUploadedFiles(email);
        this.uploadedFiles = resp.uploadedFiles;
        //console.log(this.uploadedFiles);
        this.isLoading = false;
        this.$store.commit('global/SET_LOADING', false);
      } catch (error) {
        this.isLoading = false;
        this.$store.commit('global/SET_LOADING', false);
        throw error;
      }
    },
    setFile: function(file) {
      this.file = file;
      if (this.file) {
        this.uploadStatus = this.$t("uploadsAndLinks.uploadFiles.ready");
      } else {
        this.uploadStatus = this.$t("uploadsAndLinks.uploadFiles.empty");
      }
    },
    dropGetFile: function(event) {
      const file = event.dataTransfer.files[0];
      this.file = file;
      this.fileUrl = file.name;
      this.uploadStatus = this.$t("uploadsAndLinks.uploadFiles.ready");
    },
      ValidateUpload: function(){
      this.chkprivate =false;  
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.$refs['my-warning'].show();
    },
    validateForm: async function() {
      await this.uploadFile();
    },
    uploadFile: async function() {
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      this.uploadStatus = "Uploading...";
      try {
        const timestamp = Date.now();

        let s3FileName = this.file.name;
        s3FileName = s3FileName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        s3FileName = s3FileName.replace(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
        s3FileName = s3FileName.replace(/\s/gi, ' ');
        s3FileName = `Sharing_Documents/programmatic/${timestamp}_${s3FileName}`;

        if(this.picked == "true")
        {
        this.picked = true;
        }
        if(this.picked == "false")
        {
        this.picked = false;
        }
        const fileResp = await s3.uploadFileP(s3FileName, this.file,this.picked);
        const { Location } = fileResp;

        await api.postUploadedFile({
          originalFileName: this.file.name,
          url: Location,
          isPublic :this.picked
        });

        this.$refs['my-warning'].hide();

        this.uploadStatus = this.$t("uploadsAndLinks.uploadFiles.loaded")+Location;//`File uploaded, URL generated: ${Location}`;
        this.$store.commit("global/SET_LOADING", false);
        
                this.$store.commit("global/SET_ALERT", {
                msg: this.$t("uploadsAndLinks.uploadFiles.loaded"),
                show: true,
                type: "success"
               });


        this.isLoading = false;
        this.file = null;
        this.fileUrl = null;
        this.$v.$reset();
        await this.getUploadedFiles();


      } catch (error) {
    

        this.uploadStatus = error;
        this.$store.commit("global/SET_LOADING", false);
        this.isLoading = false;

        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
          });

        throw error;
      }
    }
  }
};
</script>

<style lang="scss" >

  .VueTables thead  { 
            position: sticky;
            top: 0;
            z-index: 1;
            background-color: #fff;
        }
        .table-responsive { 
            height:600px;
            overflow:scroll;
        }
#menu-upload {
  background-color: $white;
  padding: 1rem 2rem;
}

.input-container {
  width: 100%;
}

.error-msg {
  color: $warn_red;
  font-size: 14px;
}

.drop-container,
.uploadInfo {
  width: 100%;
  height: 8rem;
  background-color: $w_2;
  border: 1px solid $wg_2;
  align-self: center;
  margin: 0rem 0;
  padding: 1rem;
}
.drop-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
 .uploadInfo {
   overflow-y: scroll;
}

.publish-btn {
  align-self: stretch;
  background: #000;
  border-radius: 0px;
  padding: 0.5rem 1rem;
}

.menu-table {
  margin-top: 3rem;
}
.download-btn {
  background-color: $black;
  color: $white;
  border-radius: 0;
  padding: 0.5rem 2rem;
  align-self: flex-end;
}
.download-btn:hover {
  color: $white;
}
</style>
<style>
.form-inline label {
  display: initial;
}
</style>
